import { ThemeConfig } from "antd";

export const themeConfig: ThemeConfig = {
    token: {
        colorPrimary: "#47cb38",
        colorBorder: "#e8e8e8",
    },
	components: {
		DatePicker: {
            colorPrimary: "#47cb38",
            activeBorderColor: "#47cb38",
            cellActiveWithRangeBg: "#e7ffe5",
            cellHoverWithRangeBg: "#baffb2",
            cellRangeBorderColor: "#47cb38",
            hoverBorderColor: "#47cb38"
        },
        Button: {
            contentFontSize: 13,
            ghostBg: "#f5f5f5"
        }
	},
};